import { useMemo } from "react";
import useGetExternalAccounts from "../../ExternalAccount/hooks/useGetExternalAccounts";
import useGetFartherManagedAccounts from "./useGetFartherManagedAccounts";
import useGetManuallyTrackedAccounts from "./useGetManuallyTrackedAccounts";
export default function useAllAccounts(clientId, authConfig) {
    const fartherManagedAccounts = useGetFartherManagedAccounts(clientId, authConfig);
    const externalAccounts = useGetExternalAccounts(clientId, authConfig);
    const manuallyTrackedAccounts = useGetManuallyTrackedAccounts(clientId, authConfig);
    const result = useMemo(() => {
        if (fartherManagedAccounts.isLoading || fartherManagedAccounts.hasError) {
            return fartherManagedAccounts;
        }
        if (externalAccounts.isLoading || externalAccounts.hasError) {
            return externalAccounts;
        }
        if (manuallyTrackedAccounts.isLoading || manuallyTrackedAccounts.hasError) {
            return manuallyTrackedAccounts;
        }
        return {
            data: {
                fartherAccounts: fartherManagedAccounts.data,
                externalAccounts: externalAccounts.data.accounts,
                manuallyTrackedAccounts: manuallyTrackedAccounts.data,
            },
            isLoading: false,
            hasError: false,
        };
    }, [externalAccounts, fartherManagedAccounts, manuallyTrackedAccounts]);
    return result;
}
//# sourceMappingURL=useAllAccounts.js.map